import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, RefreshBtn, TextInput } from '../kit';
import { font as f } from '../style';
import { C } from '../tokens';

/** The Account's lists as toggle chips, filterable. A Sandbox Fan's lists are
 *  stored by name; the brain resolves them against the Account's catalogue. */
export function ListPicker({ all, value, onChange, onRefresh, maxHeight = 150 }: { all: string[]; value: string[]; onChange: (v: string[]) => void; onRefresh?: () => Promise<unknown>; maxHeight?: number }) {
  const { t } = useTranslation('assistantCompact');
  const [q, setQ] = useState('');
  const picked = new Set(value.map((v) => v.toLowerCase()));
  // Selected first, so a long catalogue never hides what's on.
  const shown = useMemo(() => {
    const names = [...new Set([...value, ...all])];
    const hit = q.trim() ? names.filter((n) => n.toLowerCase().includes(q.trim().toLowerCase())) : names;
    return hit.sort((a, b) => Number(picked.has(b.toLowerCase())) - Number(picked.has(a.toLowerCase())));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [all, value, q]);
  const toggle = (n: string) =>
    onChange(picked.has(n.toLowerCase()) ? value.filter((v) => v.toLowerCase() !== n.toLowerCase()) : [...value, n]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {(all.length > 8 || onRefresh) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          {all.length > 8 ? <div style={{ flex: 1, minWidth: 0 }}><TextInput value={q} onChange={setQ} placeholder={t('sb.dlg.search')} /></div> : <span style={{ flex: 1 }} />}
          {onRefresh && <RefreshBtn onRefresh={onRefresh} title={t('su.refreshLists')} />}
        </div>
      )}
      <div className="cpt-thin-scroll" style={{ display: 'flex', flexWrap: 'wrap', gap: 4, maxHeight, overflowY: 'auto' }}>
        {shown.map((n) => {
          const on = picked.has(n.toLowerCase());
          return (
            <button
              key={n}
              type="button"
              onClick={() => toggle(n)}
              className={on ? undefined : 'cpt-hover-line'}
              style={{ height: 24, padding: '0 8px', display: 'flex', alignItems: 'center', gap: 4, background: on ? C.tint16 : C.input, border: `1px solid ${on ? C.tintLine45 : C.borderHi}`, borderRadius: 6, color: on ? C.text : 'var(--om-body)', font: f(500, 11.5), cursor: 'pointer', whiteSpace: 'nowrap' }}
            >
              {on && <Icon name="check" size={11} color={C.purpleLt} />}
              {n}
            </button>
          );
        })}
        {!shown.length && <span style={{ font: f(400, 12), color: C.muted }}>{t('sb.dlg.noListsFound')}</span>}
      </div>
    </div>
  );
}
